import ApartmentIcon from "@mui/icons-material/Apartment";
import AssessmentIcon from "@mui/icons-material/Assessment";
import DescriptionIcon from "@mui/icons-material/Description";
import DraftsIcon from "@mui/icons-material/Drafts";
import WorkIcon from "@mui/icons-material/Work";
import { useLocation } from "react-router-dom";
import i18n from "../../../i18n";
import MiniDrawer from "../MiniDrawer";
import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact';

export const SALES_NAVIGATION_DRAWER_TYPE_ALL = "all";

const salesDrawerActionIcons = [
    {
        label: i18n.t("page.sales_landing_page.investment_configuration"),
        icon: <AssessmentIcon />,
        link: "/sales-manager/investment-configuration/",
        drawerType: SALES_NAVIGATION_DRAWER_TYPE_ALL,
    },
    {
        label: i18n.t("page.sales_landing_page.products_table"),
        icon: <ApartmentIcon />,
        link: "/sales-manager/products",
        drawerType: SALES_NAVIGATION_DRAWER_TYPE_ALL,
    },
    {
        label: i18n.t("page.sales_landing_page.documents"),
        icon: <DescriptionIcon />,
        link: "/sales-manager/documents",
        drawerType: SALES_NAVIGATION_DRAWER_TYPE_ALL,
    },
    {
        label: i18n.t("page.sales_landing_page.drafts"),
        icon: <DraftsIcon />,
        link: "/sales-manager/drafts",
        drawerType: SALES_NAVIGATION_DRAWER_TYPE_ALL,
    },
    {
        label: i18n.t("page.sales_landing_page.sellers"),
        icon: <WorkIcon />,
        link: "/sales-manager/sellers",
        drawerType: SALES_NAVIGATION_DRAWER_TYPE_ALL,
    },
    {
        label: i18n.t("page.sales_landing_page.proposals"),
        icon: <ConnectWithoutContactIcon />,
        link: "/sales-manager/proposals",
        drawerType: SALES_NAVIGATION_DRAWER_TYPE_ALL,
    },
];

const SalesNavigationDrawer = ({
    drawerType = SALES_NAVIGATION_DRAWER_TYPE_ALL,
    extraDrawerTypes = [],
    children,
}) => {
    const location = useLocation();

    const getDrawerActionIconsContent = (drawerActionIcons) => {
        return drawerActionIcons
            .filter(
                (drawerActionIcon) =>
                    drawerActionIcon.drawerType === drawerType ||
                    extraDrawerTypes.includes(drawerActionIcon.drawerType),
            )
            .map((drawerActionIcon) => ({
                ...drawerActionIcon,
                callback: () => window.location.replace(drawerActionIcon.link),
                isActive: location.pathname === drawerActionIcon.link,
            }));
    };

    const topDrawerIcons = getDrawerActionIconsContent(salesDrawerActionIcons);

    return (
        // @ts-ignore
        <MiniDrawer
            initialOpen={true}
            topDrawerActionIcons={topDrawerIcons}
            showTopDrawerActionIcons={topDrawerIcons.length > 0}
            middleDrawerActionIcons={[]}
            showMiddleDrawerActionIcons={false}
            bottomDrawerActionIcons={[]}
            showBottomDrawerActionIcons={false}
        >
            {children}
        </MiniDrawer>
    );
};

export default SalesNavigationDrawer;
